/**
 * JamSessionButton Component
 * Button for Jam Sessions with active session indicator
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Radio } from 'lucide-react';

export const JamSessionButton = ({
  activeJamSession,
  showJamSessionPanel,
  setShowJamSessionPanel,
  setShowJamSessionModal,
}) => {
  const handleClick = () => {
    if (activeJamSession) {
      setShowJamSessionPanel(!showJamSessionPanel);
    } else {
      setShowJamSessionModal(true);
    }
  };

  return (
    <Button
      variant={activeJamSession ? 'default' : 'ghost'}
      size="sm"
      onClick={handleClick}
      className={`relative p-2 ${activeJamSession ? 'bg-orange-500/20 text-orange-400 border border-orange-500/50' : 'text-zinc-400 hover:text-white hover:bg-orange-500/20'}`}
      data-testid="jam-session-btn"
      title="Jam Sessions"
    >
      <Radio className="w-5 h-5" />
      {activeJamSession && (
        <span className="absolute -top-1 -right-1 w-2 h-2 bg-orange-400 rounded-full animate-pulse" />
      )}
    </Button>
  );
};

export default JamSessionButton;
